import Danmaku from 'danmaku/dist/esm/danmaku.dom.js'
import { io } from "socket.io-client"

var socket, danmaku;

const player = OvenPlayer.create('video', {
    disableSeekUI: true,
    sources: [
        {
            label: 'LLHLS',
            type: 'hls',
            file: 'https://eu.stream.comfytheatre.co.uk:4433/live/galax/llhls.m3u8'
        },
        {
            label: 'WebRTC',
            type: 'webrtc',
            file: 'wss://eu.stream.comfytheatre.co.uk:3334/live/galax/abr'
        },
    ]
});

player.on('ready', () => {
    socket = io(`https://${window.location.hostname}:1207`);
    danmaku = new Danmaku({
        container: document.querySelector('.ovenplayer .op-player .op-danmaku'),
        engine: 'DOM',
        speed: 140
    });
    socket.on('danmaku', (message) => {
        danmaku.emit({
            render () {
                var node = document.createElement('div');
                const stickerRegex = /@sticker\((\d+)\)/;
                const hasCode = new RegExp(stickerRegex).test(message.text);

                // Replace sticker text with the actual sticker
                if (hasCode) {
                    const code = message.text.match(stickerRegex)[1];
                    var sticker = document.createElement('img');
                    sticker.src = `./build/img/stickers/${code}_key.png`;
                    node.classList.add('danmaku-render-sticker');
                    node.appendChild(sticker);
                } else {
                    node.innerHTML = message.text;
                    node.style.color = message.color;
                    node.classList.add('danmaku-render-text');
                }

                return node;
            }
        })
    });
});

player.on('destroy', () => {
    danmaku.destroy();
    socket.disconnect();
})

window.addEventListener('resize', () => {
    if (danmaku) {
        danmaku.resize();
    }
});

window.sendMessage = (text, color) => {
    if (socket) {
        return socket.emit('danmaku', {
            text,
            color
        });
    }
};

window.sendSticker = (text) => {
    if (socket) {
        return socket.emit('danmaku', {
            text
        });
    }
};

window.toggleDanmaku = () => {
    if (danmaku) {
        if (danmaku._.visible) {
            danmaku.hide();
        } else {
            danmaku.show();
        }
        return danmaku._.visible;
    }
    return null;
}
